var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "SVG",
    clipPath: "url(#clip0_322_2025)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_322_2025",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 15
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clip0_309_1877"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.4106 0.530029H0.410645V14.53H14.4106V0.530029Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_322_2025)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.06335 9.18045C9.97451 8.26942 9.97451 6.79233 9.06335 5.88129C8.1521 4.97024 6.67471 4.97024 5.76349 5.88129C4.85227 6.79233 4.85227 8.26942 5.76349 9.18045C6.67471 10.0915 8.1521 10.0915 9.06335 9.18045Z",
    fill: "#1E1C40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.3743 4.64595C14.3414 3.90212 14.2212 3.39061 14.0487 2.9476C13.8709 2.47718 13.5975 2.05608 13.239 1.70595C12.8888 1.35034 12.4649 1.07417 11.9998 0.8991C11.554 0.726771 11.0452 0.606497 10.3012 0.573621C9.55171 0.538004 9.31363 0.529785 7.41241 0.529785C5.51122 0.529785 5.27336 0.538004 4.52664 0.570881C3.78265 0.603758 3.27105 0.724031 2.82795 0.896361C2.35744 1.07417 1.93627 1.34759 1.58606 1.70595C1.23037 2.05608 0.954158 2.47992 0.779055 2.94485C0.606693 3.39061 0.486395 3.89937 0.453512 4.64321C0.417889 5.39253 0.409668 5.63061 0.409668 7.53143C0.409668 9.43226 0.417889 9.67003 0.450772 10.4166C0.483655 11.1605 0.603953 11.672 0.776315 12.115C0.954158 12.5854 1.23037 13.0065 1.58606 13.3566C1.93627 13.7122 2.36019 13.9884 2.82521 14.1635C3.27105 14.3358 3.77991 14.4561 4.5239 14.489C5.27062 14.5218 5.50875 14.5301 7.40967 14.5301C9.3106 14.5301 9.54875 14.5218 10.2954 14.489C11.0394 14.4561 11.551 14.3358 11.9941 14.1635C12.9351 13.7996 13.6791 13.0558 14.043 12.115C14.2154 11.6692 14.3357 11.1605 14.3686 10.4166C14.4015 9.67003 14.4096 9.43195 14.4096 7.53143C14.4096 5.63088 14.4072 5.39252 14.3743 4.64595ZM7.41268 11.1276C5.42681 11.1276 3.81554 9.51689 3.81554 7.53116C3.81554 5.54541 5.42681 3.93471 7.41268 3.93471C9.39857 3.93471 11.0098 5.54541 11.0098 7.53116C11.0098 9.51689 9.3988 11.1276 7.41268 11.1276ZM11.1521 4.63225C10.6884 4.63225 10.3121 4.25636 10.3121 3.79253C10.3121 3.32869 10.6881 2.9528 11.1521 2.9528C11.6159 2.9528 11.9919 3.32869 11.9919 3.79253C11.9919 4.25636 11.6159 4.63225 11.1521 4.63225Z",
    fill: "#1E1C40"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_322_2025"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.410156 0.530029)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.627db608db12568aa7ede19f612bd728.svg";
export { ForwardRef as ReactComponent };